import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextProvider, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-form.css';

var getClassNameList = classNames.bind(styles);
var useFormCallback = function (name, transformer) {
    var contextData = useUitkContext().data;
    var fieldChangeCallback = (contextData !== null && contextData !== void 0 ? contextData : {}).fieldChangeCallback;
    // If (!fieldChangeCallback) {
    //   throw new Error(
    //     'fieldChangeCallback prop should be set in any UitkForm in the parent tree of a field using this hook'
    //   );
    // }
    return React.useCallback(function (event) {
        var transformedEvent = transformer(event);
        var _a = transformedEvent.currentTarget, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.id, id = _c === void 0 ? '' : _c;
        fieldChangeCallback === null || fieldChangeCallback === void 0 ? void 0 : fieldChangeCallback({ name: name, value: value, id: id }, transformedEvent);
        return transformedEvent;
    }, [name, transformer, fieldChangeCallback]);
};
var UitkForm = React.forwardRef(function (props, ref) {
    var hasRequiredFieldIndicator = props.hasRequiredFieldIndicator, children = props.children, className = props.className, onFieldChange = props.onFieldChange, formProps = __rest(props, ["hasRequiredFieldIndicator", "children", "className", "onFieldChange"]);
    var baseClass = 'uitk-form';
    var wrapperClassNames = getClassNameList(baseClass, { 'has-required-indicator': hasRequiredFieldIndicator }, className);
    var contextData = {
        hasRequiredFieldIndicator: hasRequiredFieldIndicator,
        fieldChangeCallback: onFieldChange
    };
    return (React.createElement(UitkContextProvider, { config: { context: 'uitk-form-context', data: contextData } },
        React.createElement("form", __assign({ ref: ref }, formProps, { className: wrapperClassNames }), children)));
});
UitkForm.displayName = 'UitkForm';

export { UitkForm, useFormCallback };
